import { useEffect, useRef } from 'react';
import { checkCrossTabLogout, removeTokens, clearStaleLogoutEvents } from '@/network/token';
import { useAuthStore } from '../store/authStore';

export function useCrossTabAuth() {
  const { clearAuth } = useAuthStore();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const hasLoggedOutRef = useRef(false);

  useEffect(() => {
    clearStaleLogoutEvents();

    const checkLogout = () => {
      if (hasLoggedOutRef.current) return;
      try {
        if (checkCrossTabLogout()) {
          hasLoggedOutRef.current = true;
          removeTokens();
          clearAuth();
          // ProtectedRoute will handle the redirect to /login
        }
      } catch {
        clearStaleLogoutEvents();
      }
    };

    intervalRef.current = setInterval(checkLogout, 1000);

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'auth_logout_event' && event.newValue) {
        setTimeout(checkLogout, 100);
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) setTimeout(checkLogout, 100);
    };

    window.addEventListener('storage', handleStorageChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      window.removeEventListener('storage', handleStorageChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [clearAuth]);

  return null;
}
